import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Text } from "@mantine/core";

import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";

import { useCertCheckout } from "reducers/certCheckoutSlice";

import { CheckoutLogoutButton } from "views/pages/checkout/components/LogoutButton";

import { clearCachedFormData } from "./checkoutCache";
import styles from "./EventCheckoutSuccessPage.module.scss";

export function ProfessionalCertCheckoutSuccessPage() {
	const { checkoutInfo } = useCertCheckout();

	const hasCertUrl = checkoutInfo.cert_url;

	useEffect(() => {
		clearCachedFormData();
		// if this is a webview, send the data back to the webview
		if (window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({
					status: "success",
				}),
			);
			return;
		}
	}, []);

	return (
		<div className={styles.checkout_success_container}>
			<div className={`${styles.success_title_container} `}>
				<Container className="text-center py-6">
					<p className={styles.title_text}>
						Our team is now processing your request, and you can track the status at <br />
						<Text component={Link} to="/profile" fw="bold" fz={25} c={"#00AB84"}>
							{"Profile > Cert Requests"}
						</Text>
					</p>
				</Container>
				<div className="d-flex gap-2 mt-4">
					<Link to="/cert_orders">
						<ThemedButton>View Certificate Status</ThemedButton>
					</Link>
					{hasCertUrl && (
						<Link to={checkoutInfo.cert_url}>
							<ThemedButton>View Certificate</ThemedButton>
						</Link>
					)}
					<Link to="/">
						<LightThemedButton>Back to Home</LightThemedButton>
					</Link>
				</div>
			</div>
			<div className="mt-4">
				<CheckoutLogoutButton />
			</div>
		</div>
	);
}
